import { createContext } from 'react';
import type { ITheme } from '@vanialabs/ui-engine';

export interface IThemeContextValue {
  theme: ITheme | null;
  isLoading: boolean;
  fellBackToDefault: boolean;
}

/**
 * Undefined default (not a stub object) so useTheme() can detect and throw
 * on missing provider, instead of silently handing out a null theme.
 */
export const ThemeContext = createContext<IThemeContextValue | undefined>(undefined);
